__turbopack_context__.v({
  "form": "-7BskW_form",
  "form--wide": "-7BskW_form--wide",
});
